export default "__VITE_ASSET__a4f3c46c__"